import { CONFIGCONSTANTS } from './../config/app-constants';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class NewtimeDropdownService {
  timesArray: any[];
  constructor() { 
    this.timesArray = [];
    this.generateValuesArray();
  }
  
  generateValuesArray() {
    const x =  CONFIGCONSTANTS["customTimePickerDropdown"]["minutesInterval"] || 5; // minutes interval
    const includeClose =  CONFIGCONSTANTS["customTimePickerDropdown"]["includeClosedOption"] || true; // minutes interval
    let tt = 0; // start time
    const ap = ['AM', 'PM']; // AM-PM

    // loop to increment the time and push results in array
    for (let i = 0; tt < 24 * 60; i++) {
        const hh = Math.floor(tt / 60); // getting hours of day in 0-24 format
        const mm = (tt % 60); // getting minutes of the hour in 0-55 format
        this.timesArray[i] = ("0" + (hh % 12)).slice(-2) + ':' + ("0" + mm).slice(-2) + ' ' +
        ap[Math.floor(hh / 12)]; // pushing data in array in [00:00 - 12:00 AM/PM format]
        tt = tt + x;
    }
    if (includeClose) {
      this.timesArray.push('By Appt.');
    }
  }
  
  getTimeArray() {
    // return this.timesArray;
    // https://bvprjs.atlassian.net/browse/MNL-470 : Resolve this issue
    return ["12:00 AM", "12:30 AM", "01:00 AM", "01:30 AM", "02:00 AM", "02:30 AM", "03:00 AM", "03:30 AM", "04:00 AM", "04:30 AM", "05:00 AM", "05:30 AM", "06:00 AM", "06:30 AM", "07:00 AM", "07:30 AM", "08:00 AM", "08:30 AM", "09:00 AM", "09:30 AM", "10:00 AM", "10:30 AM", "11:00 AM", "11:30 AM", "12:00 PM",
     "12:30 PM", "01:00 PM", "01:30 PM", "02:00 PM", "02:30 PM", "03:00 PM", "03:30 PM", "04:00 PM", "04:30 PM", "05:00 PM", "05:30 PM", "06:00 PM", "06:30 PM", "07:00 PM", "07:30 PM", "08:00 PM", "08:30 PM", "09:00 PM", "09:30 PM", "10:00 PM", "10:30 PM", "11:00 PM", "11:30 PM", "By Appt."];
  }
  getBlankDayArray() {
    return [
      {
        from: '',
        to: '',
        day: 'Monday',
        disabledUptoIndex: -1
      },
      {
        from: '',
        to: '',
        day: 'Tuesday',
        disabledUptoIndex: -1
      },
      {
        from: '',
        to: '',
        day: 'Wednesday',
        disabledUptoIndex: -1
      },
      {
        from: '',
        to: '',
        day: 'Thursday',
        disabledUptoIndex: -1
      },
      {
        from: '',
        to: '',
        day: 'Friday',
        disabledUptoIndex: -1
      },
      {
        from: '',
        to: '',
        day: 'Saturday',
        disabledUptoIndex: -1
      },
      {
        from: '',
        to: '',
        day: 'Sunday',
        disabledUptoIndex: -1
      }
    ];
  }
}
